<template>
  <div class="content">
    <div class="wrap-1200" style="margin-top: 50px;">
      <el-table :data="tableData" stripe :header-cell-style="{ 'padding-left': '4px', 'padding-right': '4px' }">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID" width="150"></el-table-column>
        <el-table-column prop="member" label="名称"></el-table-column>
        <el-table-column prop="money" label="金额"></el-table-column>
        <el-table-column label="创建时间">
          <template #default="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template v-slot:="scope">
            <div class="table-row-options-warp">
              <el-button type="danger" size="small" @click="handleEdit(scope.row)">购买</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      user: {},
      tableData: []
    };
  },
  created() {
    this.load()
  },
  methods: {


    update() {
      let data = {
        nickname: this.user.nickname,
        email: this.user.email,
        mobile: this.user.mobile,
        username: this.user.username,
        schoo1: this.user.schoo1,
        remake: this.user.remake,
      }
      this.request.put('admin-api/system/user/profile/pcUpdate', data
      ).then(res => {
        if (res.code == 0) {
          this.$message.success('修改成功');
        } else {
          this.$message.error(res.msg);
        }

      })

    },
    load() {
      this.request.get("admin-api/system/deji/page", {
        params: {
          isBuy: 0,
          status: 0,
          pageSize: this.pageSize,
          pageNo: this.pageNo
        }
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list
        }

      })
    },
    handleEdit(item) {
      this.createD(item)
    },
    createD(item) {
      let data = {
        spuId: item.id,
        spuName: item.member,
        price: item.money,
        type: 1,
      }
      this.request.post('admin-api/pay/new-order/create', data
      ).then(res => {
        if (res.code == 0) {
          let datas = {
            id: res.data,
            channelCode: 'alipay_pc',
            returnUrl: 'https://www.baidu.con',
          }
          this.request.post('admin-api/pay/order/submit', datas
          ).then(res => {
            if (res.code == 0) {
              window.open(res.data.displayContent, '_blank')
            } else {
              this.$message.error(res.msg);
            }
          })



        } else {
          this.$message.error(res.msg);
        }
      })
    }

  }
};
</script>

<style scoped lang="scss">
.user-profile {
  margin-top: 40px;
}
</style>
